import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SeverityPills } from '@shape/lighthouse-components';
import { StatusKey } from 'components/StatusSummary/helper';

export const caseEvaluationMap: SeverityMap = {
  low: 1,
  medium: 2,
  high: 3,
  very_high: 4,
};

export const SeverityPanel = ({
  statusCounts,
  selectedSeverity,
  getLabel,
  onClick,
  showPills = true,
  isInPdfReport,
  keyMap,
}: SeverityPanelProps) => {
  const { t } = useTranslation();

  const severityNumbers = useMemo(() => {
    const entries = Object.entries(keyMap);
    const uniqueEntries = entries.filter(
      (entry, index, arr) => arr.findIndex(([, value]) => value === entry[1]) === index,
    );
    return uniqueEntries.sort(([, a], [, b]) => Number(b) - Number(a));
  }, [keyMap]);

  const formattedStatusCounts = statusCounts;

  return (
    <>
      <div>
        <div className="box-title">{getLabel('title')}</div>
      </div>

      <div className="severity-items">
        {isInPdfReport && (
          <div className="box-pdf-cd-wrapper">
            <div className="box-pdf-divider">
              <strong className="box-value">{statusCounts[StatusKey.Total]}</strong>
              <div className="box-caption">{t('case:status_count_panel.status.total.title')}</div>
            </div>
          </div>
        )}
        {severityNumbers.map(([item, number]) => {
          return (
            <div
              className={`severity-outer-item ${item} ${
                selectedSeverity?.includes(item) ? 'severity-active' : ''
              }`}
              key={item}
              onClick={() => {
                if (item === 'Warning' || item === 'Information') {
                  return onClick?.(['Warning', 'Information']);
                }
                return onClick?.([item]);
              }}
            >
              <div className="severity-item">
                <strong className="box-value">{formattedStatusCounts[item] ?? 0}</strong>
                {showPills && <SeverityPills severity={number} totalPills={4} />}
              </div>
              <div className="box-caption">{getLabel(String(number))}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};
